import { User } from './typeUser';

export enum SenderType {
  USER = 'USER',
  AI = 'AI',
  TOOL = 'TOOL',
}

export interface IChat {
  id: string;
  title: string;
  is_telegram: boolean;
  telegram_chat_it: string;
  is_ai_enabled: boolean;
  createdAt: string;
  updatedAt: string;
  thread_id: string;
  user: User;
}

export interface IMessage {
  id: string;
  content: string;
  senderType: SenderType;
  tool_calls: unknown | null;
  is_processed: boolean;
  is_mention: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface ICallAdmin {
  user: User;
  chats: IChat[];
}

export enum NotifyCategory {
  CALL_ADMIN = 'CALL_ADMIN',
  SUPPORT_TICKET = 'SUPPORT_TICKET',
  TREASURE = 'TREASURE',
  GAS_STATION = 'GAS_STATION',
  PING = 'PING',
}
